import styled from '@emotion/styled'

import media from '../../../../styles/media'
import { fonts } from '../../../../styles/theme'
import { v2, v2Black, v2White, v2Shark } from '../../_themes'

const S = {}

const theme = ({ themeColor }) => {
  const themes = {
    dark: v2,
    black: v2Black,
    white: v2White,
    light: v2White,
    darkBlue: v2,
    shark: v2Shark,
  }

  return themes[themeColor]
}

S.Footer = styled.footer`
  font-family: ${fonts.menu};
  padding-block-start: 1.25rem;

  ${media.sm`
    padding-block-start: 1.875rem;
  `};

  ${media.md`
    padding-block-start: 2rem;
  `};


  ${theme};
`

S.Container = styled.div`
  margin-inline: auto;
  box-sizing: border-box;

  .footer-wrapper {
    text-align: center;
    isolation: isolate;
    position: relative;
    .footer-bottom-bg {
      height: 100%;
      inset-inline-start: 0;
      object-fit: cover;
      position: absolute;
      width: 100%;
      z-index: -1;
    }
  }

  .footer-bottom {
    padding-block: 2rem;
    padding-inline: 1.25rem;

    ${media.sm`
      padding-block: 1.5rem;
      padding-inline: 2.5rem;
    `};

    a,
    [tabindex='0'] {
      text-decoration: none;

      &:focus {
        outline: 0.125rem solid rgba(160, 160, 160, 0.75);
        outline-offset: 0;
        box-shadow: none;
        text-decoration: underline;
      }
    }
  }

  .logo-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.25rem;

    ${media.sm`
      width: auto;
    `};
  }

  .footer-copyright {
    display: flex;
    padding-block: 2.5rem;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
    padding-inline: 1.25rem;
    max-width: 90rem;
    margin-inline: auto;

    ${media.sm`
      padding-top: 1.5rem;
      padding-inline: 2.5rem;
      flex-direction: row;
    `};

    ${media.xl`
      padding-inline: 0;
    `};

    p {
      margin: 0;
      word-break: normal;
    }
  }

  .copyright-text {
    display: flex;
    align-items: center;
      
    &::before {
      content: '';
      width: 0.0625rem;
      height: 1.125rem;
      margin-inline-end: 0.625rem;
    }
  }

  .sony-copyright {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 0.5rem;

    ${media.sm`
      row-gap: 0.625rem;
    `};
  }

  .language-toggle {
    width: 100%;
    ${media.sm`
      width: auto;
      max-width: 100%;
    `};

    .trigger-title {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      transition: color 0.2s ease-in-out;
    }

    .trigger-icon {
      flex-shrink: 0;
      transition: color 0.2s ease-in-out;
    }

    .dropdown-trigger {
      width: 100%;
      outline: 0.125rem solid;
      outline-color: rgba(160, 160, 160, 0.75);
      border-radius: 0.5rem;
      transition: 0.2s ease-in-out;
      transition-property: outline-color, background-color;
      &:focus {
        outline-color: rgba(255, 255, 255, 1);
        outline-offset: 0;
        box-shadow: none;
      }
      @media (hover: hover) {
        &:hover {
          outline-color: rgba(255, 255, 255, 1);
          outline-offset: 0;
          box-shadow: none;
        }
      }
      &[aria-expanded='true'] {
        background-color: #272727;
        ${media.sm`
          outline-color: transparent;
          html:not([dir]) &,
          [dir='ltr'] & {
            border-top-right-radius: 0rem;
          }
          [dir='rtl'] & {
            border-top-left-radius: 0rem;
          }
        `};
      }
    }
    .dropdown-menu-content {
      background-color: #272727;
      ${media.sm`
        border-radius: 0.5rem;
        min-width: 15rem;
        max-height: 20rem;
        > div {
          scrollbar-width: none;
          .content {
            .fade {
              &::after {
                height: 3rem;
                background: linear-gradient(180deg, rgba(39, 39, 39, 0.3) 0%, #272727 100%);
                inset-block-start: calc(100% - 3rem);
              }
            }
          }
        }
        html:not([dir]) &,
        [dir='ltr'] & {
          border-bottom-right-radius: 0rem;
        }
        [dir='rtl'] & {
          border-bottom-left-radius: 0rem;
        }
      `};
    }
    .text-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: 0.2s ease-in-out;
      transition-property: color, background-color;
      &[data-active='true'] {
        background-color: rgba(255, 255, 255, 0.06);
      }
      &:not([data-disabled='true']) {
        @media (hover: hover) {
          &:hover {
            background-color: rgba(255, 255, 255, 0.06);
          }
        }
      }
    }
  }
`

S.Sections = styled.div`
  display: flex;
  flex-direction: column;

  ${media.sm`
    flex-direction: row;
    column-gap: 1.25rem;
  `};

  ${media.md`
    column-gap: 1.875rem;
  `};
`

export default S
